import styled from 'styled-components';

import {
    Button,
    Card,
    spaceMixin,
} from '@zillow/constellation';

export const StyledButton = styled(Button)`
    width: 100%;
`;

export const StyledCard = styled(Card)`
    height: 314px;
    padding-left: ${spaceMixin('xl')};
    padding-right: ${spaceMixin('xl')};
`;
